import { cn } from "@/lib/utils";

interface FieldHintProps {
  children: React.ReactNode;
  className?: string;
}

export function FieldHint({ children, className }: FieldHintProps) {
  return (
    <p className={cn("mt-1 text-xs text-text-muted", className)}>{children}</p>
  );
}
